import { useRef, useState } from 'react';
import { FormInputProps } from '@/@types/form.types';
import EListPopupPickerWithSearchV2 from '@/components/everridge/EListPopupPickerWithSearchV2';
import { useSuperAdminDataApartmentsLookupInfiniteApi } from '@/features/superAdmin/features/data/shared/hooks/useSuperAdminDataLookupsInfiniteApi';
import { useSuperAdminLookupInfiniteScroll } from '@/features/superAdmin/features/data/shared/lookups/useSuperAdminLookupInfiniteScroll';

type Props<T extends {}> = {
    tenantId?: string | null;
    hotelId?: string | null;
    selectVariant?: 'single' | 'multi';
    showSearch?: boolean;
    icon?: React.FC<React.SVGProps<SVGSVGElement>>;
    addResetButton?: boolean;
} & FormInputProps<T>;

const SuperAdminRoomLookup = <T extends {}>(props: Props<T>) => {
    const [searchValue, setSearchValue] = useState('');
    const {
        placeholder = 'Select room',
        label = 'Room',
        tenantId,
        hotelId,
        addResetButton = true,
        disabled,
    } = props;
    const loaderRef = useRef<HTMLDivElement>(null);

    const { items, fetchNextPage, hasNextPage, isFetchingNextPage } =
        useSuperAdminDataApartmentsLookupInfiniteApi(tenantId, searchValue, hotelId);

    useSuperAdminLookupInfiniteScroll({
        loaderRef,
        hasNextPage,
        isFetchingNextPage,
        fetchNextPage,
    });

    return (
        <EListPopupPickerWithSearchV2
            {...props}
            label={label}
            placeholder={placeholder}
            list={items}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
            addResetButton={addResetButton}
            disabled={disabled || !tenantId}
            ref={loaderRef}
        />
    );
};

export default SuperAdminRoomLookup;
